import { Label, Preloader, ProgressBar, Text } from 'pctComponents/atoms';
import './style.scss';

import React, { useState, useEffect, useRef, useMemo } from 'react';
import { VscListTree } from 'react-icons/vsc';
import { IoClose } from 'react-icons/io5';

import { TreeMap } from '..';
import { connect } from 'react-redux';
import useCards from 'pctHooks/useCards';

type Props = {
    updateConfigContentsMap?: any;
    collection?: Array<object> | any;
};
function ContentMyProgress({ collection, updateConfigContentsMap }: Props) {
    const [menuState, setMenuState] = useState('');
    const [dataMap, setDataMap] = useState(collection);
    const [dataMyProgress, setDataMyProgress] = useState(null as any);
    const setProgressStateRef = useRef(null as any);
    const progressInfoRef = useRef(null as any);

    const nodeCodeCurrent = collection?.nodeCode || null;
   
    const collectionMyProgress = useMemo(() => {
        if (dataMyProgress) {
            return {
                data: {
                    ...dataMyProgress,
                    nodeType: 'LEARNING',
                    status: 'PUBLISHED',
                },
                elementType: 'NODE',
            };
        }
        return null;
    }, [dataMyProgress]);

    const {
        concluidedText,
        initialProgressState,
        statusElement,
    } = useCards({
        collection: { data: dataMyProgress ? dataMyProgress : {} },
        progressInfoRef: progressInfoRef,
        setProgressStateRef: setProgressStateRef,
    });

    setProgressStateRef.current = initialProgressState();
    progressInfoRef.current = initialProgressState();


    const openCloseControl = (e) => {
        setMenuState(menuState === '' || menuState === 'close' ? 'open' : 'close');
        e.stopPropagation();
    };

    useEffect(() => {
        if (updateConfigContentsMap.forceCurrentComplete) {
            let tempCollection = dataMap;
            tempCollection.forceCurrentComplete = true;
            setDataMap(tempCollection);
        } else {
            setDataMap(collection);
        }
    }, [collection, updateConfigContentsMap]);

    // useEffect(() => {

    //     if(dataMyProgress){
    //         console.log("dataMyProgress", dataMyProgress);
    //     }

    // }, [dataMyProgress]);

    const scorm = !!collection.content && !!collection.content.scorm;
    if (!collection.contentEnrollment || scorm) return <></>;


    return (
        <div className="ContentMyProgress">
            {menuState === 'open' && (
                <div
                    className="overlayMap"
                    onClick={(e) => {
                        openCloseControl(e);
                    }}
                />
            )}

            <button
                className="ContentMyProgressBtn"
                onClick={(e) => {
                    openCloseControl(e);
                }}
            >
                <VscListTree />
                <Text text={'MEU PROGRESSO'} component={'small'} />
            </button>

            <div className={`treeMapContent ${menuState}`}>
                <div
                    className="closeBtn"
                    onClick={(e) => {
                        openCloseControl(e);
                    }}
                >
                    <IoClose />
                </div>

                {dataMyProgress && (
                    <>
                        <div className="headerMapInfos">
                            <Text className="titlMapInfos" text={'Meu progresso'} component={'p'} />
                            <Text
                                text={
                                    'Acompanhe o status da sua matrícula e veja o que falta para concluir o seu treinamento.'
                                }
                                component={'small'}
                            />

                            <div className="headerMapProgress">
                                <div className="dataProgressInit">
                                    <Text
                                        text={`${
                                            dataMyProgress?.editable
                                                ? '<b>PROGRESSO</b>'
                                                : `<b>PROGRESSO:</b> ${initialProgressState()}%`
                                        }`}
                                        component={'small'}
                                    />
                                    <Text
                                        text={`${concluidedText()}`}
                                        component={'small'}
                                        className="progressStatusMobile"
                                    />
                                </div>
                                <div className="dataProgressEnd">
                                    <Text
                                        text={`Média para aprovação: ${
                                            Math.trunc(dataMyProgress?.masteryScore * 10) / 10 ?? 0
                                        }`}
                                        component={'small'}
                                        className="approvalAverage"
                                    />
                                    {!dataMyProgress?.editable && (
                                        <Text
                                            text={`Média final: ${
                                                Math.trunc(dataMyProgress?.nodeEnrollment?.grade * 10) / 10 ?? 0
                                            }`}
                                            component={'small'}
                                            className="finalAverage"
                                        />
                                    )}

                                    <Text
                                        text={`${concluidedText()}`}
                                        component={'small'}
                                        className="progressStatusDesktop"
                                    />
                                </div>
                                <ProgressBar
                                    collection={collectionMyProgress}
                                    percentage={initialProgressState()}
                                    status={statusElement()}
                                    myProgressBar
                                />
                            </div>
                            <div className="headerMapLine">
                                <Label text={dataMyProgress?.label} className="label" />
                                <Text text={dataMyProgress?.title} component={'p'} />
                            </div>
                        </div>
                    </>
                )}

                <div className="treeMapBase">
                    {menuState === 'open' && (
                        <TreeMap
                            collection={dataMap}
                            nodeCodeCurrent={nodeCodeCurrent}
                            closeMap={openCloseControl}
                            setDataMyProgress={setDataMyProgress}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (store) => ({
    updateConfigContentsMap: store.configContentsMapState.configContentsMap,
});

export default connect(mapStateToProps, null)(ContentMyProgress);
